

export default function ErrorPage() {

  return (
    <>
     <h1>Oh Oh error Boo.</h1>
    </>
  )
}